import { useNavigate } from 'react-router-dom'
import React, { useEffect } from 'react'
import { useModal } from '../../context/ModalContext'
import { useEndConnectionMutation } from '../../shared/queryHooks'
import './index.css'

function ConnectionEnd ({ connection, isSpaceLeaderOrAbove }) {
  const { clearModal } = useModal()
  const navigate = useNavigate()
  const endConnection = useEndConnectionMutation()
  const leaveButton = React.createRef<any>()

  function handleLeave () {
    localStorage.setItem('fromConnectionEnd', 'true')
    navigate(-1)
    clearModal()
  }

  async function handleArchive () {
    await endConnection.mutateAsync(connection?.uid)
    localStorage.setItem('fromConnectionEnd', 'true')
    navigate(-1)
    clearModal()
  }

  useEffect(() => {
    leaveButton.current.focus()
  }, [])

  const CanArchive = () => isSpaceLeaderOrAbove && !connection?.endTime && new Date(connection?.startTime) < new Date()

  const connectionEndActionDisplay = (
    <div className="end-connect-actions">
      {CanArchive() && (
        <div className="button danger" onClick={handleArchive} tabIndex={0}>
          End Connect for All
        </div>
      )}
      <div ref={leaveButton} className="button secondary" onClick={() => handleLeave()} tabIndex={0}>
        Leave Connect
      </div>
      <div className="end-connect-cancel" onClick={clearModal} tabIndex={0}>
        Cancel
      </div>
    </div>
  )

  return <div className="end-connection-modal-content">{connectionEndActionDisplay}</div>
}

export default ConnectionEnd
